import axios from "axios";
import setAuthToken from "../auth/aut-headers";


import {BASE_API_URL} from '../base_url'

const API_URL = BASE_API_URL + "/api/contractortradedef";



class ContractortradedefService {

  editcontractortradedef(data:any) {
    //console.log(query)
    return axios
      .put(API_URL, data)
      .then(response => {
        return response;
      });
  }

  addcontractortradedef(data:any) {
    //console.log(query)
    return axios
      .post(API_URL, data)
      .then(response => {
        return response.data;
      });
  }
  contractortradedefExist(name:string, id : number){
    return axios
      .post(API_URL + '/exist', {name: name, id : id})
      .then(response => {
        return response.data;
      });
  }

  deletecontractortradedef(fairId:number) {
    //console.log(query)
    return axios
      .delete(API_URL + '/'+fairId)
      .then(response => {
        return response.data;
      });
  }

  


  getcontractortradedefs(query:string) {
    return axios
      .get(API_URL + "?" + query, {
        params:{
           
        }
      })
      .then(response => {
        return response.data;
      });
  }


 

}

export default new ContractortradedefService();